export default "__VITE_ASSET__ojV0ZHKI__"